<div class="container mx-auto px-4 py-6">
    <div class="max-w-3xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden">
      <div class="px-4 py-6 bg-gray-50 sm:px-6">
        <div class="flex items-start justify-between">
          <h2 class="text-xl font-medium text-gray-900">Your Profile</h2>
        </div>
        <div class="mt-2 text-sm leading-6 text-gray-500 text-center" *ngIf="user">
          <div *ngIf="user?.profilePicture; else noImage">
            <img class="mx-auto h-32 w-32 flex-shrink-0 rounded-full" [src]="user.profilePicture" alt="{{ user.name }}">
          </div>
          <ng-template #noImage>
            <div [ngClass]="namebkC(user)" class="mx-auto h-32 w-32 rounded-full flex items-center justify-center text-white font-bold text-4xl">
              {{ nameinitial(user) }}
            </div>
          </ng-template>
        </div>
      </div>
      <div class="px-4 py-4 sm:px-6">
        <form (ngSubmit)="updateProfile()" #profileForm="ngForm" class="space-y-6">
          <div *ngIf="user">
            <label for="name" class="block text-sm font-medium text-gray-700">Name</label>
            <input type="text" id="name" name="name" [(ngModel)]="user.name" required
                   class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
          </div>
          <div *ngIf="user">
            <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
            <input type="email" id="email" name="email" [(ngModel)]="user.email" required
                   class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
          </div>
          <div class="flex items-center">
            <button type="submit"
                    class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              Save Changes
            </button>
          </div>
        </form>
      </div>
      <div class="px-4 py-4 sm:px-6 border-t border-gray-200">
        <h3 class="text-lg font-medium text-gray-900">Reset Password</h3>
        <form (ngSubmit)="resetPassword()" #resetPasswordForm="ngForm" class="space-y-6 mt-4">
          <div>
            <label for="currentPassword" class="block text-sm font-medium text-gray-700">Current Password</label>
            <input type="password" id="currentPassword" name="currentPassword" [(ngModel)]="currentPassword" required
                   class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
          </div>
          <div>
            <label for="newPassword" class="block text-sm font-medium text-gray-700">New Password</label>
            <input type="password" id="newPassword" name="newPassword" [(ngModel)]="newPassword" required
                   [ngClass]="{'border-red-500': newPassword && confirmPassword && newPassword !== confirmPassword}"
                   class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
          </div>
          <div>
            <label for="confirmPassword" class="block text-sm font-medium text-gray-700">Confirm Password</label>
            <input type="password" id="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword" required
                   [ngClass]="{'border-red-500': newPassword && confirmPassword && newPassword !== confirmPassword}"
                   class="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm">
          </div>
          <div *ngIf="newPassword && confirmPassword && newPassword !== confirmPassword" class="text-red-500 text-sm">
            Passwords do not match.
          </div>
          <div class="flex items-center">
            <button type="submit"
                    class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
              Reset Password
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  